// extracted by mini-css-extract-plugin
export default {"FullWidthMasterOverlay":"add-master-to-deck-or-open-details-action-overlay_FullWidthMasterOverlay__QCiLe"};